module.exports = __webpack_public_path__ + "img/Icon-Family-History.939ebefb.svg";